import React from "react";

const LogOut = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M16.1246 12.0004C16.1246 11.8015 16.0456 11.6107 15.9049 11.47C15.7643 11.3294 15.5735 11.2504 15.3746 11.2504H4.40158L6.36258 9.57036C6.43743 9.50628 6.49893 9.42808 6.54356 9.34022C6.5882 9.25237 6.61509 9.15659 6.6227 9.05835C6.63031 8.9601 6.6185 8.86132 6.58794 8.76764C6.55738 8.67396 6.50867 8.58722 6.44458 8.51236C6.3805 8.43751 6.3023 8.37601 6.21444 8.33138C6.12659 8.28675 6.03081 8.25986 5.93256 8.25224C5.83432 8.24463 5.73554 8.25644 5.64186 8.287C5.54818 8.31756 5.46143 8.36628 5.38658 8.43036L1.88658 11.4304C1.80425 11.5008 1.73814 11.5882 1.69282 11.6866C1.64749 11.785 1.62402 11.892 1.62402 12.0004C1.62402 12.1087 1.64749 12.2157 1.69282 12.3141C1.73814 12.4125 1.80425 12.5 1.88658 12.5704L5.38658 15.5704C5.53775 15.6998 5.73415 15.7639 5.93256 15.7485C6.13098 15.7331 6.31516 15.6395 6.44458 15.4884C6.57401 15.3372 6.63808 15.1408 6.6227 14.9424C6.60732 14.744 6.51375 14.5598 6.36258 14.4304L4.40258 12.7504H15.3746C15.5735 12.7504 15.7643 12.6713 15.9049 12.5307C16.0456 12.39 16.1246 12.1993 16.1246 12.0004Z"
        fill="#FA1B1B"
      />
      <path
        d="M9.375 8C9.375 8.702 9.375 9.053 9.544 9.306C9.61679 9.41478 9.71022 9.50821 9.819 9.581C10.072 9.75 10.423 9.75 11.125 9.75H15.375C15.9717 9.75 16.544 9.98705 16.966 10.409C17.3879 10.831 17.625 11.4033 17.625 12C17.625 12.5967 17.3879 13.169 16.966 13.591C16.544 14.0129 15.9717 14.25 15.375 14.25H11.125C10.423 14.25 10.072 14.25 9.819 14.418C9.71012 14.4911 9.61668 14.5849 9.544 14.694C9.375 14.947 9.375 15.298 9.375 16C9.375 18.828 9.375 20.243 10.254 21.121C11.132 22 12.546 22 15.374 22H16.374C19.204 22 20.617 22 21.496 21.121C22.375 20.243 22.375 18.828 22.375 16V8C22.375 5.172 22.375 3.757 21.496 2.879C20.617 2 19.203 2 16.375 2H15.375C12.546 2 11.132 2 10.254 2.879C9.375 3.757 9.375 5.172 9.375 8Z"
        fill="#FA1B1B"
      />
    </svg>
  );
};

export default LogOut;
